export const Logo = `${process.env.PUBLIC_URL || ""}/logo-new.png`;
export default Logo;
